import { siteProps } from "@/components/settings/api/networkUtils";

import { socialLoginConst } from "./socialLoginConstant";

export const SITE_CODE =
  typeof siteProps != "undefined" &&
  typeof siteProps?.country_code != "undefined" &&
  siteProps?.country_code
    ? siteProps?.country_code
    : "IN";

export default {
  jsLoadCheck: {
    fb: 0,
    google: 0,
  },
  init: function (_confObj) {
    var self = this;

    window.fbAsyncInit = function () {
      // FB JavaScript SDK configuration and setup
      FB.init({
        appId: socialLoginConst.fbAppIds[siteProps?.country_code]
          ? socialLoginConst.fbAppIds[siteProps?.country_code]
          : socialLoginConst.fbAppIds["IN"], // FB App ID
        cookie: true, // enable cookies to allow the server to access the session
        xfbml: true, // parse social plugins on this page
        version: "v3.3", // use graph api version 2.8
      });

      // Check whether the user already logged in
      FB.getLoginStatus(function (response) {
        if (response.status === "connected") {
          console.log("already connected");
        }
      });
    };
    this.loadFbJs();
    this.loadGoogleJs(_confObj);
  },
  loadFbJs: function () {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  },
  loadGoogleJs: function (_confObj) {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://apis.google.com/js/api:client.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "google-jssdk");
    this.bindGooglesignIn(_confObj);
  },
  bindGooglesignIn: function (_confObj) {
    var self = this;
    if (typeof gapi == "undefined") {
      if (this.jsLoadCheck.google < 20) {
        setTimeout(() => {
          this.jsLoadCheck.google = this.jsLoadCheck.google + 1;
          this.bindGooglesignIn(_confObj);
        }, 200);
      }
    } else {
      gapi.load("auth2", function () {
        // Retrieve the singleton for the GoogleAuth library and set up the client.
        self.auth2 = gapi.auth2.getAuthInstance({
          client_id: socialLoginConst.googleClientId,
          cookiepolicy: "single_host_origin",
          scope: "email profile",
          fetch_basic_profile: false,
        });
        if (self.auth2 == null) {
          self.auth2 = gapi.auth2.init({
            client_id: socialLoginConst.googleClientId,
            cookiepolicy: "single_host_origin",
            scope: "email profile",
            fetch_basic_profile: false,
          });
        }
        self.attachGoogleSignin(_confObj);
      });
    }
  },
  doSocialLogin: function (_confObj) {
    if (_confObj) {
      if (_confObj.provider && _confObj.provider == "facebook") {
        this.fbLogin(_confObj);
      } else if (_confObj.provider && _confObj.provider == "google") {
        this.googleLogin(_confObj);
      }
    }
  },
  fbLogin: function (_confObj) {
    var self = this;

    if (typeof FB != "undefined") {
      FB.login(
        function (response) {
          if (response.authResponse) {
            _confObj.authResponse = response.authResponse;
            self.getFbUserData(_confObj);
          } else if (
            typeof response.authResponse == "undefined" &&
            typeof response.status == "undefined"
          ) {
            _confObj.error = true;
            _confObj.userCancel = true;
            _confObj.onSuccess(_confObj);
          } else {
            _confObj.error = true;
            _confObj.onSuccess(_confObj);
          }
        },
        {
          scope: "email",
        },
      );
    } else {
      _confObj.error = true;
      _confObj.userCancel = true;
      _confObj.onSuccess(_confObj);
    }
  },
  getFbUserData: function (_confObj) {
    var self = this;
    FB.api(
      "/me",
      {
        locale: "en_US",
        fields: "id,first_name,last_name,email,link,gender,picture",
      },
      function (response) {
        if (response.error) {
          _confObj.error = true;
          _confObj.errMsg = response.error.message;
          _confObj.onSuccess(_confObj);
        } else {
          _confObj.userDataResp = response;
          _confObj.onSuccess(_confObj);
        }
      },
    );
  },
  attachGoogleSignin: function (_confObj) {
    var self = this;
    if (!document.getElementById("googleSignIn")) {
      setTimeout(() => {
        this.attachGoogleSignin(_confObj);
      }, 100);
    } else {
      var _elm = document.getElementById("googleSignIn");
      this.auth2.attachClickHandler(
        _elm,
        {},
        function (googleUser) {
          var profile = googleUser.getBasicProfile();
          _confObj.error = false;
          _confObj.authResponse = {};
          _confObj.userDataResp = {};
          _confObj.authResponse.accessToken =
            googleUser.getAuthResponse().id_token;
          _confObj.userDataResp.first_name = profile.getGivenName();
          _confObj.userDataResp.last_name = profile.getFamilyName();
          _confObj.userDataResp.email = profile.getEmail();

          _confObj.onSuccess(_confObj);
        },
        function (error) {
          _confObj.error = true;
          _confObj.onSuccess(_confObj);
        },
      );
    }
  },

  InitiateSiteRegister: function (_confObj) {
    var reqData = new FormData();
    var mobileNumber = { countryCode: "91", mobileNumber: "1231237689" };

    reqData.append(
      "email",
      _confObj.userDataResp.email
        ? _confObj.userDataResp.email
        : "fraud25@gmail.com",
    );
    reqData.append("mobileNumber", JSON.stringify(mobileNumber));
    reqData.append(
      "socialProvider",
      _confObj.provider == "fb" ? "facebook" : _confObj.provider,
    );
    reqData.append(
      "socialAccessToken",
      _confObj.authResponse.accessToken
        ? _confObj.authResponse.accessToken
        : "",
    );
    reqData.append(
      "fullName",
      (_confObj.userDataResp.first_name
        ? _confObj.userDataResp.first_name
        : "") +
        " " +
        (_confObj.userDataResp.last_name
          ? _confObj.userDataResp.last_name
          : ""),
    );

    fetch(socialLoginConst.socialRegisterUrl, {
      method: "POST",
      body: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Source-Country": siteCode,
        "X-Language-Code": "en",
        "X-Source-Site-Context": channel_context,
      },
    })
      .then(function (resp) {
        if (_confObj.vue && _confObj.vue.showHideLoader) {
          _confObj.vue.showHideLoader(false);
        }
        _confObj.onSuccess(resp);
      })
      .catch(function (err) {
        if (_confObj.vue && _confObj.vue.showHideLoader) {
          _confObj.vue.showHideLoader(false);
          let temp = {
            active: true,
            message: err.message,
            theme: "error",
          };
          _confObj.vue.$emit("notify", "handle-notification", temp);
        }
      });
  },

  InitiateSiteLogin: function (_confObj) {
    var reqData = new FormData();
    var mobileNumber = {
      countryCode: "91",
      mobileNumber: "1231237689",
    };
    reqData.append(
      "social_provider",
      _confObj.provider == "fb" ? "facebook" : _confObj.provider,
    );
    reqData.append(
      "username",
      _confObj.authResponse.accessToken
        ? _confObj.authResponse.accessToken
        : "",
    );

    fetch(socialLoginConst.socialLoginUrl, {
      method: "POST",
      body: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Source-Country": siteCode,
        "X-Language-Code": "en",
        "X-Source-Site-Context": channel_context,
        "cache-control": "no-cache",
      },
    })
      .then(function (resp) {
        if (_confObj.vue && _confObj.vue.showHideLoader) {
          _confObj.vue.showHideLoader(false);
        }
        _confObj.onSuccess(resp);
      })
      .catch(function (err) {
        if (_confObj.vue && _confObj.vue.showHideLoader) {
          _confObj.vue.showHideLoader(false);
          let temp = {
            active: true,
            message: err.message,
            theme: "error",
          };
          _confObj.vue.$emit("notify", "handle-notification", temp);
        }
      });
  },
};
